module.exports = __webpack_public_path__ + "static/media/05.4b169a36.png";